@if (!shouldShowPendingCallBanner && !shouldShowUnpaidLlmChatBanner && !showInstructionBanner) {
  <div class="tw-fixed tw-left-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
    <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
  </div>
}

@if (shouldShowPendingCallBanner || shouldShowUnpaidLlmChatBanner || showInstructionBanner) {
  <div class="tw-fixed tw-left-0 tw-top-0 tw-right-0 tw-z-10 tw-flex justify-between tw-items-center tw-pt-5 tw-pb-4 tw-px-6 tw-gap-2 tw-bg-white">
    <div class="tw-flex-none tw-flex tw-flex-row tw-items-center tw-gap-2" (click)="back()">
      <cs-icon class="tw-h-7 tw-w-7 tw-text-black" [iconName]="'arrow_back'"></cs-icon>
    </div>
    <h1 class="tw-text-400 tw-font-bold" i18n="@@help">Help</h1>
    <div class="tw-w-7 tw-h-2 tw-aspect-square border"></div>
  </div>
}

<div class="tw-flex tw-flex-col tw-h-full tw-bg-gray-100" [ngClass]="{ 'loading': inProcess } ">
  <div [ngClass]="shouldShowPendingCallBanner || shouldShowUnpaidLlmChatBanner ? 'tw-pt-16' : 'tw-pt-20'" class="tw-flex-1 tw-overflow-y-auto tw-flex tw-flex-col tw-pb-20">

    @if ((viewType === ViewTypes.FirstPage || viewType === ViewTypes.NextPage) && (!shouldShowPendingCallBanner && !shouldShowUnpaidLlmChatBanner && !showInstructionBanner)) {
      <div class="operator">
        <img src="/assets/images/bot.gif" />
        @if (viewType === ViewTypes.FirstPage) {
          <div class="desc">
            <div class="fontS1" i18n="@@hiImYourCureskinAdvisor">
        Hi {{user?.get('PatientName')?.split(' ')[0]}}, I'm your Cure
        Advisor
      </div>
            <div class="fw-600 fontL1" i18n="@@howMayIHelpYou">
        How may I help you?
      </div>
          </div>
        }
        @if (viewType === ViewTypes.NextPage) {
          <div class="desc">
            <div class="fontS1" i18n="@@HiHereAreTheDetails">
        Hi {{user?.get('PatientName')?.split(' ')[0]}}, Here are the details
      </div>
            <div class="title fontL1">
              {{question?.responseTitle || question?.question}}
            </div>
          </div>
        }
      </div>
    }

    <support-unpaid-doctor-call-widget [user]="user" [regimen]="latestActiveRegimen" [experiments]="experiments" [supportView]="true" (showDrCallBannerToggle)="shouldShowDoctorCallBanner($event)" (showLlmChatBannerToggle)="shouldShowLlmChatBanner($event)"></support-unpaid-doctor-call-widget>

    @if (isNewHelpUiExp && viewType === ViewTypes.FirstPage && user?.isPaid() && (recentSupportTicketList$ | async)?.length) {
      <section class="tw-px-4 tw-pt-4">
        <div style="text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);" class="tw-text-300 tw-text-gray-800 tw-font-body tw-mb-3" i18n="@@recentSupportTickets">Recent Queries</div>
        <div class="tw-overflow-x-auto">
          <div class="tw-flex tw-space-x-2 tw-pb-2 tw-w-full">
            @for (ticket of (recentSupportTicketList$ | async); track ticket) {
              <div
                (click)="viewTicket(ticket)"
                class="tw-relative tw-w-[312px] tw-flex-shrink-0">
                <div class="tw-relative tw-bg-white tw-border tw-border-[#E6E6E6] tw-rounded-xl tw-shadow-sm tw-overflow-hidden">
                  @if ((pendingResponseMap && pendingResponseMap[ticket.objectId])) {
                    <div style="position: absolute; top: 0; right: 16px; margin-top: 0px; z-index: 999;">
                      <img src="/assets/gifs/blinking-red-dot.gif" alt="red-blink-circle" style="width: 10px; height: 10px;" />
                    </div>
                  }
                  <div class="tw-px-4 tw-pt-4 tw-pb-[42px]">
                    <div class="tw-flex tw-font-body tw-justify-between tw-text-100 tw-text-gray-400 tw-items-center tw-mb-[10px]">
                      <span class="tw-capitalize">
                        {{ ticket?.llmResponse && ticket?.llmResponse?.category !== 'default' ? ticket?.llmResponse?.category : 'Query' }}
                      </span>
                      <span>{{ ticket.createdAt | date: 'dd MMM yyyy, hh:mm a' }}</span>
                    </div>
                    <div class="tw-font-body tw-text-base tw-text-200 tw-text-gray-800 tw-leading-tight">
                      {{ truncateString(ticket.title || ticket.supportQuestion?.questionLanguageString[ticket.languagePreference], 100) }}
                    </div>
                  </div>
                  <div class="tw-absolute tw-bottom-0 tw-left-0 tw-right-0">
                    @if (!(pendingResponseMap && pendingResponseMap[ticket.objectId])) {
                      <div class="tw-border-t tw-ml-3 tw-mr-3 tw-border-gray-200"></div>
                    }
                    <div class="tw-px-4 tw-py-2 tw-flex tw-items-center tw-justify-between tw-text-base tw-text-200" [ngClass]="{ 'tw-bg-teal-100': pendingResponseMap && pendingResponseMap[ticket.objectId] }">
                      @if (pendingResponseMap && pendingResponseMap[ticket.objectId]) {
                        <span i18n="@@awaitingResponse" class="tw-text-teal-600">AWAITING YOUR RESPONSE</span>
                      }
                      @if ((!(pendingResponseMap && pendingResponseMap[ticket.objectId]) && ticket.teams[0] !== 'bot' && ticket.status === appConfig.Shared.Ticket.status.Pending) || ticket.status === appConfig.Shared.Ticket.status.RequestClosure) {
                        <span i18n="@@inProcessTicket" class="tw-text-teal-600">IN-PROCESS</span>
                      }
                      @if ( ticket.teams[0] === 'bot' && ticket.status === appConfig.Shared.Ticket.status.Pending && !(pendingResponseMap && pendingResponseMap[ticket.objectId])) {
                        <span i18n="@@openTicket" class="tw-text-red-400">OPEN</span>
                      }
                      <img src="/assets/icons/chevron_right_teal.svg" alt="chevron right"/>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </section>
    }

    @if (!isNewHelpUiExp && viewType === ViewTypes.FirstPage && user?.isPaid() && (recentSupportTicketList$ | async)?.length) {
      <section class="queries">
        <div class="header fontL1 fw-500" i18n="@@recentSupportTickets">Recent Queries</div>
        <div class="of-x-auto">
          <div class="question-holder default">
            @for (ticket of (recentSupportTicketList$ | async); track ticket) {
              <div class="question recent-queries" (click)="viewTicket(ticket)" [ngClass]="{ 'highlight green': ticket.hasUnreadMessage }">
                <div class="timestamp">
                  {{ ticket.createdAt | date: 'dd MMM YYY, hh:mm a' }}
                </div>
                <div class="mT10 fontR bdr-btm pB10">
                  {{ truncateString(ticket.title ||
                  ticket.supportQuestion?.questionLanguageString[ticket.languagePreference],
                  20 )}}
                </div>
                <div class="mT10">
                  <div class="status tw-uppercase" i18n="@@open">Open</div>
                  <i class="cs-icon-arrow"></i>
                </div>
              </div>
            }
          </div>
        </div>
      </section>
    }

    <div class="content" [ngClass]="{ 'bg-white': inProcess }">
      @if (inProcess || questions?.length) {
        <support-component-selection [question]="question" [questions]="questions" [loading]="inProcess" [newSupportQuestionId] = "newSupportQuestionId" ></support-component-selection>
      }
    </div>
    @if (viewType === ViewTypes.FirstPage && queriesCount && !user?.isPaid()) {
      <div class="others">
        <div>
          <span class="underline" i18n="@@allQueries" (click)="viewAllQuery()">All Queries</span>
        </div>
      </div>
    }
    @if (user?.isPaid()) {
      <div class="others">
        <div>
          <span class="underline" routerLink="/faq" i18n="@@faqs">FAQs</span>
        </div>
      </div>
    }
    @if (question.outputComponent !== appConfig.Shared.Support.component.SELECT_SUB_QUERY) {
      <div class="feedback-section">
        <div class="feedback">
          <div class="flex-grow" i18n="@@wasThisHelpfull">Was this helpful?</div>
          <div class="icons">
            <em (click)="updateFeedback(true)" [ngClass]="{ 'cs-icon-like-filled anim-like': isHelpfull, 'cs-icon-like': !isHelpfull }"></em><em (click)="updateFeedback(false)" [ngClass]="{ 'cs-icon-dislike-filled anim-like': isHelpfull === false, 'cs-icon-dislike': isHelpfull !== false }"></em>
          </div>
        </div>
        @if (user?.get('orderState') !== appConfig.Shared.User.OrderState.DELIVERED) {
          <a class="feedback" (click)="showCallPopup = true">
            <div class="flex-grow" i18n="@@stillNotResolved">
        Still not resolved?
      </div>
            <div class="icons">
              <em class="cs-icon-phone-in-talk font18"></em><span class="pL10 fontS1" i18n="@@callUs">Call Us</span>
            </div>
          </a>
        }
      </div>
    }
    @if (!isKeyboardVisible) {
      <div class="cam-icon" (click)="cameraClick()">
        <img src="/assets/icons/teal-camera-help.svg" class="tw-w-[48px] tw-aspect-square">
      </div>
    }
  </div>
  <div class="floating-nav tw-flex-none tw tw-h-20 tw-flex tw-flex-row tw-border-none">
    @if (festivalDelayAlertEnabled) {
      <div class="festive-alert">
        <div class="fontS3 fw-700" i18n="@@expectDelayInResponse">
      Please expect delay in response due to ongoing festivities.
      </div>
        <div class="fontS4" i18n="@@weWillGetBackToEnquiries">
      We will get back to your enquiries as soon as we can.
      </div>
      </div>
    }
    @if (isBottomNavExperimentActive) {
      <app-bottom-nav [user]="user" />
    } @else {
      <div class="navHolder tw-h-20">
        <div class="tw-h-full tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect" (callback)="onTabChange(0)">
          <div class="tw-flex-none tw-w-11 tw-h-1 tw-rounded-br tw-rounded-bl tw-bg-white"></div>
          <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
            <cs-icon class="tw-h-7 tw-w-7 tw-text-gray-500" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_home.svg"'></cs-icon>
            <div class="tw-font-body tw-text-200 tw-text-gray-500" i18n="@@home">Home</div>
          </div>
        </div>
        <div class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect">
          <div class="tw-flex-none tw-w-11 tw-h-1 tw-rounded-br tw-rounded-bl tw-bg-teal-400"></div>
          <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
            <cs-icon class="tw-h-7 tw-w-7 tw-text-teal-400" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_help_solid.svg"'></cs-icon>
            <div class="tw-font-body tw-text-200 tw-text-teal-400" i18n="@@help">Help</div>
          </div>
        </div>
        @if (userStatus.PAID) {
          <div class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect" (callback)="onTabChange(4);shopClick()">
            <div class="tw-flex-none tw-w-11 tw-h-1 tw-bg-white tw-bg-white"></div>
            <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
              <cs-icon class="tw-h-7 tw-w-7 tw-text-gray-500" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_storefront.svg"'></cs-icon>
              <div class="tw-font-body tw-text-200 tw-text-gray-500" i18n="@@shop">Shop</div>
            </div>
          </div>
        }
        @if (!userStatus.PAID) {
          <div class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect" (callback)="cameraClickHome()">
            <div class="tw-flex-none tw-w-11 tw-h-1 tw-bg-white"></div>
            <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
              <cs-icon class="tw-h-7 tw-w-7 tw-text-gray-500" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_photo_camera.svg"'></cs-icon>
              <div class="tw-font-body tw-text-200 tw-text-gray-500" i18n="@@photo">Photo</div>
            </div>
          </div>
        }
        <div class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect" (callback)="onTabChange(2)">
          <div class="tw-flex-none tw-w-11 tw-h-1 tw-rounded-br tw-rounded-bl tw-bg-white"></div>
          <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
            <cs-icon class="tw-h-7 tw-w-7 tw-text-gray-500" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_sanitizer.svg"'></cs-icon>
            <div class="tw-font-body tw-text-200 tw-text-gray-500" i18n="@@treatment">
                Treatment
              </div>
          </div>
        </div>
        @if (showExploreTab) {
          <div class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect" (callback)="onTabChange(3);exploreClick()">
            <div class="tw-flex-none tw-w-11 tw-h-1 tw-rounded-br tw-rounded-bl tw-bg-white"></div>
            <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
              <cs-icon class="tw-h-7 tw-w-7 tw-text-gray-500" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_manage_search.svg"'></cs-icon>
              <div class="tw-font-body tw-text-200 tw-text-gray-500" i18n="@@explore">Explore</div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
<call-us [show]="showCallPopup" (close)="showCallPopup = false" (onCallNeeded)="onCallNeeded()"></call-us>@if (showChatSupportPrompt) {
<pop-up [show]="true" (close)="showChatSupportPrompt = false" [class]="'bdr-rad-5'">
  <div class="p20">
    <div class="fontL2 mB5 fw-600" i18n="@@sorryToHearThat">
    Sorry to hear that 😞
  </div>
    <div class="fontR" i18n="@@wouldYouLikeToOpenTicket">
    Would you like to chat with your skin advisor?
  </div>
    <cs-button [class]="'secondary btn-xs w100 mT25'" (callback)="showChatSupportPrompt = false"><cs-button-text i18n="@@noThanksNew">No, Thanks</cs-button-text></cs-button><cs-button [class]="'primary btn-xs w100 mT15'" (callback)="createTicket()" [loading]="ticketInProcess"><cs-button-text i18n="@@yes">Yes</cs-button-text></cs-button>
  </div>
</pop-up>
}
